export class ManufacturerAuction {

  constructor() { }

  manufacturerName: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/home/models/manufacturer-auction.ts